import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-dialog-ver-documento',
  templateUrl: './dialog-ver-documento.component.html',
  styleUrls: ['./dialog-ver-documento.component.css']
})
export class DialogVerDocumentoComponent implements OnInit {
  //s3ServiceRoute: any = "https://0ehm5uf0oi.execute-api.us-east-2.amazonaws.com/dev/financials/api/v1";
  s3ServiceRoute: any = "https://0ehm5uf0oi.execute-api.us-east-2.amazonaws.com/dev/warehouse/api/v1";
  //s3ServiceRoute: any = "http://localhost:3000/api/v1";
  pdf: any
  message: string | null = null


  constructor(private sanitizer: DomSanitizer, private http: HttpClient, @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<DialogVerDocumentoComponent>) { }

  ngOnInit(): void {

    console.log(this.data)
    this.getFile()
  }

  getFile() {
    this.http.get(`${this.s3ServiceRoute}/getFileOrdenSalida/${this.data.data.numberOrdenSalida}`)
      .subscribe(
        {
          next: (res: any) => {
            {
              let binary = '';

              let bytes = new Uint8Array(res.data);
              let len = bytes.byteLength;
              for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
              }


              this.pdf = this.sanitizer.bypassSecurityTrustResourceUrl(binary)
              console.log(this.pdf)
            }
          },
          error: (err) => {
            {
              console.log(err)
              this.message = "Error al obtener el PDF del Orden de Servicio"
            }
          }
        }
        /*       (res: any) => {
        
              let binary = '';
        
              let bytes = new Uint8Array(res.data);
              let len = bytes.byteLength;
              for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
              }
        
              this.pdf=this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + binary)
        
        
        
            } */
      )
  }

  close() {
    this.dialogRef.close();
  }

}
